/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as AuthenticatedRouteImport } from './../../routes/_authenticated'
import { Route as AdminRouteImport } from './../../routes/admin'
import { Route as LoginRouteImport } from './../../routes/login'
import { Route as AuthenticatedAiIndexRouteImport } from './../../routes/_authenticated/ai/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './../../routes/_authenticated/analytics/index'
import { Route as AuthenticatedAppointmentsIndexRouteImport } from './../../routes/_authenticated/appointments/index'
import { Route as AuthenticatedAuditIndexRouteImport } from './../../routes/_authenticated/audit/index'
import { Route as AuthenticatedAuditEventIdRouteImport } from './../../routes/_authenticated/audit/$eventId'
import { Route as AuthenticatedConversationsIndexRouteImport } from './../../routes/_authenticated/conversations/index'
import { Route as AuthenticatedConversationsConversationIdRouteImport } from './../../routes/_authenticated/conversations/$conversationId'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './../../routes/_authenticated/integrations/index'
import { Route as AuthenticatedIntegrationsIntegrationIdRouteImport } from './../../routes/_authenticated/integrations/$integrationId'
import { Route as AuthenticatedOpportunitiesIndexRouteImport } from './../../routes/_authenticated/opportunities/index'
import { Route as AuthenticatedOpportunitiesOpportunityIdRouteImport } from './../../routes/_authenticated/opportunities/$opportunityId'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './../../routes/_authenticated/organizations/index'
import { Route as AuthenticatedOverviewIndexRouteImport } from './../../routes/_authenticated/overview/index'
import { Route as AuthenticatedPurchasesIndexRouteImport } from './../../routes/_authenticated/purchases/index'
import { Route as AuthenticatedQueuesIndexRouteImport } from './../../routes/_authenticated/queues/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './../../routes/_authenticated/settings/index'
import { Route as AuthenticatedStoreStoreIdRouteImport } from './../../routes/_authenticated/store/$storeId'
import { Route as AuthenticatedStoresIndexRouteImport } from './../../routes/_authenticated/stores/index'
import { Route as AuthenticatedStoresStoreIdRouteImport } from './../../routes/_authenticated/stores/$storeId'
import { Route as AuthenticatedSystemIndexRouteImport } from './../../routes/_authenticated/system/index'
import { Route as AuthenticatedTeamIndexRouteImport } from './../../routes/_authenticated/team/index'
import { Route as AuthenticatedTeamStaffIdRouteImport } from './../../routes/_authenticated/team/$staffId'
import { Route as AuthenticatedUsersIndexRouteImport } from './../../routes/_authenticated/users/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './../../routes/_authenticated/users/$userId'
import { Route as AuthenticatedAiFollowupsIndexRouteImport } from './../../routes/_authenticated/ai/followups/index'
import { Route as AuthenticatedAiPromptIndexRouteImport } from './../../routes/_authenticated/ai/prompt/index'
import { Route as AuthenticatedAiRunsAiRunIdRouteImport } from './../../routes/_authenticated/ai/runs/$aiRunId'
import { Route as AuthenticatedOrganizationsOrganizationIdIndexRouteImport } from './../../routes/_authenticated/organizations/$organizationId/index'
import { Route as AuthenticatedQueuesQueueIndexRouteImport } from './../../routes/_authenticated/queues/$queue/index'
import { Route as AuthenticatedQueuesQueueJobsJobIdRouteImport } from './../../routes/_authenticated/queues/$queue/jobs/$jobId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAiIndexRoute = AuthenticatedAiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppointmentsIndexRoute =
  AuthenticatedAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditEventIdRoute =
  AuthenticatedAuditEventIdRouteImport.update({
    id: '/audit/$eventId',
    path: '/audit/$eventId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsIndexRoute =
  AuthenticatedConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsConversationIdRoute =
  AuthenticatedConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsIntegrationIdRoute =
  AuthenticatedIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOpportunitiesIndexRoute =
  AuthenticatedOpportunitiesIndexRouteImport.update({
    id: '/opportunities/',
    path: '/opportunities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOpportunitiesOpportunityIdRoute =
  AuthenticatedOpportunitiesOpportunityIdRouteImport.update({
    id: '/opportunities/$opportunityId',
    path: '/opportunities/$opportunityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOverviewIndexRoute =
  AuthenticatedOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasesIndexRoute =
  AuthenticatedPurchasesIndexRouteImport.update({
    id: '/purchases/',
    path: '/purchases/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQueuesIndexRoute =
  AuthenticatedQueuesIndexRouteImport.update({
    id: '/queues/',
    path: '/queues/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoreStoreIdRoute =
  AuthenticatedStoreStoreIdRouteImport.update({
    id: '/store/$storeId',
    path: '/store/$storeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoresIndexRoute =
  AuthenticatedStoresIndexRouteImport.update({
    id: '/stores/',
    path: '/stores/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoresStoreIdRoute =
  AuthenticatedStoresStoreIdRouteImport.update({
    id: '/stores/$storeId',
    path: '/stores/$storeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSystemIndexRoute =
  AuthenticatedSystemIndexRouteImport.update({
    id: '/system/',
    path: '/system/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeamIndexRoute = AuthenticatedTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamStaffIdRoute =
  AuthenticatedTeamStaffIdRouteImport.update({
    id: '/team/$staffId',
    path: '/team/$staffId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiFollowupsIndexRoute =
  AuthenticatedAiFollowupsIndexRouteImport.update({
    id: '/ai/followups/',
    path: '/ai/followups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiPromptIndexRoute =
  AuthenticatedAiPromptIndexRouteImport.update({
    id: '/ai/prompt/',
    path: '/ai/prompt/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiRunsAiRunIdRoute =
  AuthenticatedAiRunsAiRunIdRouteImport.update({
    id: '/ai/runs/$aiRunId',
    path: '/ai/runs/$aiRunId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdIndexRoute =
  AuthenticatedOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/organizations/$organizationId/',
    path: '/organizations/$organizationId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQueuesQueueIndexRoute =
  AuthenticatedQueuesQueueIndexRouteImport.update({
    id: '/queues/$queue/',
    path: '/queues/$queue/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQueuesQueueJobsJobIdRoute =
  AuthenticatedQueuesQueueJobsJobIdRouteImport.update({
    id: '/queues/$queue/jobs/$jobId',
    path: '/queues/$queue/jobs/$jobId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/audit/$eventId': typeof AuthenticatedAuditEventIdRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdRoute
  '/store/$storeId': typeof AuthenticatedStoreStoreIdRoute
  '/stores/$storeId': typeof AuthenticatedStoresStoreIdRoute
  '/team/$staffId': typeof AuthenticatedTeamStaffIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ai/': typeof AuthenticatedAiIndexRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/audit/': typeof AuthenticatedAuditIndexRoute
  '/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/overview/': typeof AuthenticatedOverviewIndexRoute
  '/purchases/': typeof AuthenticatedPurchasesIndexRoute
  '/queues/': typeof AuthenticatedQueuesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/stores/': typeof AuthenticatedStoresIndexRoute
  '/system/': typeof AuthenticatedSystemIndexRoute
  '/team/': typeof AuthenticatedTeamIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/ai/runs/$aiRunId': typeof AuthenticatedAiRunsAiRunIdRoute
  '/ai/followups/': typeof AuthenticatedAiFollowupsIndexRoute
  '/ai/prompt/': typeof AuthenticatedAiPromptIndexRoute
  '/organizations/$organizationId/': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/queues/$queue/': typeof AuthenticatedQueuesQueueIndexRoute
  '/queues/$queue/jobs/$jobId': typeof AuthenticatedQueuesQueueJobsJobIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/audit/$eventId': typeof AuthenticatedAuditEventIdRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdRoute
  '/store/$storeId': typeof AuthenticatedStoreStoreIdRoute
  '/stores/$storeId': typeof AuthenticatedStoresStoreIdRoute
  '/team/$staffId': typeof AuthenticatedTeamStaffIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ai': typeof AuthenticatedAiIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/opportunities': typeof AuthenticatedOpportunitiesIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/overview': typeof AuthenticatedOverviewIndexRoute
  '/purchases': typeof AuthenticatedPurchasesIndexRoute
  '/queues': typeof AuthenticatedQueuesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/stores': typeof AuthenticatedStoresIndexRoute
  '/system': typeof AuthenticatedSystemIndexRoute
  '/team': typeof AuthenticatedTeamIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/ai/runs/$aiRunId': typeof AuthenticatedAiRunsAiRunIdRoute
  '/ai/followups': typeof AuthenticatedAiFollowupsIndexRoute
  '/ai/prompt': typeof AuthenticatedAiPromptIndexRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/queues/$queue': typeof AuthenticatedQueuesQueueIndexRoute
  '/queues/$queue/jobs/$jobId': typeof AuthenticatedQueuesQueueJobsJobIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/_authenticated/audit/$eventId': typeof AuthenticatedAuditEventIdRoute
  '/_authenticated/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/_authenticated/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/_authenticated/opportunities/$opportunityId': typeof AuthenticatedOpportunitiesOpportunityIdRoute
  '/_authenticated/store/$storeId': typeof AuthenticatedStoreStoreIdRoute
  '/_authenticated/stores/$storeId': typeof AuthenticatedStoresStoreIdRoute
  '/_authenticated/team/$staffId': typeof AuthenticatedTeamStaffIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/ai/': typeof AuthenticatedAiIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_authenticated/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/overview/': typeof AuthenticatedOverviewIndexRoute
  '/_authenticated/purchases/': typeof AuthenticatedPurchasesIndexRoute
  '/_authenticated/queues/': typeof AuthenticatedQueuesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/stores/': typeof AuthenticatedStoresIndexRoute
  '/_authenticated/system/': typeof AuthenticatedSystemIndexRoute
  '/_authenticated/team/': typeof AuthenticatedTeamIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/ai/runs/$aiRunId': typeof AuthenticatedAiRunsAiRunIdRoute
  '/_authenticated/ai/followups/': typeof AuthenticatedAiFollowupsIndexRoute
  '/_authenticated/ai/prompt/': typeof AuthenticatedAiPromptIndexRoute
  '/_authenticated/organizations/$organizationId/': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/_authenticated/queues/$queue/': typeof AuthenticatedQueuesQueueIndexRoute
  '/_authenticated/queues/$queue/jobs/$jobId': typeof AuthenticatedQueuesQueueJobsJobIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/audit/$eventId'
    | '/conversations/$conversationId'
    | '/integrations/$integrationId'
    | '/opportunities/$opportunityId'
    | '/store/$storeId'
    | '/stores/$storeId'
    | '/team/$staffId'
    | '/users/$userId'
    | '/ai/'
    | '/analytics/'
    | '/appointments/'
    | '/audit/'
    | '/conversations/'
    | '/integrations/'
    | '/opportunities/'
    | '/organizations/'
    | '/overview/'
    | '/purchases/'
    | '/queues/'
    | '/settings/'
    | '/stores/'
    | '/system/'
    | '/team/'
    | '/users/'
    | '/ai/runs/$aiRunId'
    | '/ai/followups/'
    | '/ai/prompt/'
    | '/organizations/$organizationId/'
    | '/queues/$queue/'
    | '/queues/$queue/jobs/$jobId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/audit/$eventId'
    | '/conversations/$conversationId'
    | '/integrations/$integrationId'
    | '/opportunities/$opportunityId'
    | '/store/$storeId'
    | '/stores/$storeId'
    | '/team/$staffId'
    | '/users/$userId'
    | '/ai'
    | '/analytics'
    | '/appointments'
    | '/audit'
    | '/conversations'
    | '/integrations'
    | '/opportunities'
    | '/organizations'
    | '/overview'
    | '/purchases'
    | '/queues'
    | '/settings'
    | '/stores'
    | '/system'
    | '/team'
    | '/users'
    | '/ai/runs/$aiRunId'
    | '/ai/followups'
    | '/ai/prompt'
    | '/organizations/$organizationId'
    | '/queues/$queue'
    | '/queues/$queue/jobs/$jobId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/admin'
    | '/login'
    | '/_authenticated/audit/$eventId'
    | '/_authenticated/conversations/$conversationId'
    | '/_authenticated/integrations/$integrationId'
    | '/_authenticated/opportunities/$opportunityId'
    | '/_authenticated/store/$storeId'
    | '/_authenticated/stores/$storeId'
    | '/_authenticated/team/$staffId'
    | '/_authenticated/users/$userId'
    | '/_authenticated/ai/'
    | '/_authenticated/analytics/'
    | '/_authenticated/appointments/'
    | '/_authenticated/audit/'
    | '/_authenticated/conversations/'
    | '/_authenticated/integrations/'
    | '/_authenticated/opportunities/'
    | '/_authenticated/organizations/'
    | '/_authenticated/overview/'
    | '/_authenticated/purchases/'
    | '/_authenticated/queues/'
    | '/_authenticated/settings/'
    | '/_authenticated/stores/'
    | '/_authenticated/system/'
    | '/_authenticated/team/'
    | '/_authenticated/users/'
    | '/_authenticated/ai/runs/$aiRunId'
    | '/_authenticated/ai/followups/'
    | '/_authenticated/ai/prompt/'
    | '/_authenticated/organizations/$organizationId/'
    | '/_authenticated/queues/$queue/'
    | '/_authenticated/queues/$queue/jobs/$jobId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/ai/': {
      id: '/_authenticated/ai/'
      path: '/ai'
      fullPath: '/ai/'
      preLoaderRoute: typeof AuthenticatedAiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments/': {
      id: '/_authenticated/appointments/'
      path: '/appointments'
      fullPath: '/appointments/'
      preLoaderRoute: typeof AuthenticatedAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit/$eventId': {
      id: '/_authenticated/audit/$eventId'
      path: '/audit/$eventId'
      fullPath: '/audit/$eventId'
      preLoaderRoute: typeof AuthenticatedAuditEventIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/': {
      id: '/_authenticated/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthenticatedConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/$conversationId': {
      id: '/_authenticated/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof AuthenticatedConversationsConversationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/$integrationId': {
      id: '/_authenticated/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/integrations/$integrationId'
      preLoaderRoute: typeof AuthenticatedIntegrationsIntegrationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities/': {
      id: '/_authenticated/opportunities/'
      path: '/opportunities'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities/$opportunityId': {
      id: '/_authenticated/opportunities/$opportunityId'
      path: '/opportunities/$opportunityId'
      fullPath: '/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/overview/': {
      id: '/_authenticated/overview/'
      path: '/overview'
      fullPath: '/overview/'
      preLoaderRoute: typeof AuthenticatedOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchases/': {
      id: '/_authenticated/purchases/'
      path: '/purchases'
      fullPath: '/purchases/'
      preLoaderRoute: typeof AuthenticatedPurchasesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queues/': {
      id: '/_authenticated/queues/'
      path: '/queues'
      fullPath: '/queues/'
      preLoaderRoute: typeof AuthenticatedQueuesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/store/$storeId': {
      id: '/_authenticated/store/$storeId'
      path: '/store/$storeId'
      fullPath: '/store/$storeId'
      preLoaderRoute: typeof AuthenticatedStoreStoreIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stores/': {
      id: '/_authenticated/stores/'
      path: '/stores'
      fullPath: '/stores/'
      preLoaderRoute: typeof AuthenticatedStoresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stores/$storeId': {
      id: '/_authenticated/stores/$storeId'
      path: '/stores/$storeId'
      fullPath: '/stores/$storeId'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/system/': {
      id: '/_authenticated/system/'
      path: '/system'
      fullPath: '/system/'
      preLoaderRoute: typeof AuthenticatedSystemIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/': {
      id: '/_authenticated/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AuthenticatedTeamIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/$staffId': {
      id: '/_authenticated/team/$staffId'
      path: '/team/$staffId'
      fullPath: '/team/$staffId'
      preLoaderRoute: typeof AuthenticatedTeamStaffIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/followups/': {
      id: '/_authenticated/ai/followups/'
      path: '/ai/followups'
      fullPath: '/ai/followups/'
      preLoaderRoute: typeof AuthenticatedAiFollowupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/prompt/': {
      id: '/_authenticated/ai/prompt/'
      path: '/ai/prompt'
      fullPath: '/ai/prompt/'
      preLoaderRoute: typeof AuthenticatedAiPromptIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai/runs/$aiRunId': {
      id: '/_authenticated/ai/runs/$aiRunId'
      path: '/ai/runs/$aiRunId'
      fullPath: '/ai/runs/$aiRunId'
      preLoaderRoute: typeof AuthenticatedAiRunsAiRunIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/$organizationId/': {
      id: '/_authenticated/organizations/$organizationId/'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queues/$queue/': {
      id: '/_authenticated/queues/$queue/'
      path: '/queues/$queue'
      fullPath: '/queues/$queue/'
      preLoaderRoute: typeof AuthenticatedQueuesQueueIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queues/$queue/jobs/$jobId': {
      id: '/_authenticated/queues/$queue/jobs/$jobId'
      path: '/queues/$queue/jobs/$jobId'
      fullPath: '/queues/$queue/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedQueuesQueueJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAuditEventIdRoute: typeof AuthenticatedAuditEventIdRoute
  AuthenticatedConversationsConversationIdRoute: typeof AuthenticatedConversationsConversationIdRoute
  AuthenticatedIntegrationsIntegrationIdRoute: typeof AuthenticatedIntegrationsIntegrationIdRoute
  AuthenticatedOpportunitiesOpportunityIdRoute: typeof AuthenticatedOpportunitiesOpportunityIdRoute
  AuthenticatedStoreStoreIdRoute: typeof AuthenticatedStoreStoreIdRoute
  AuthenticatedStoresStoreIdRoute: typeof AuthenticatedStoresStoreIdRoute
  AuthenticatedTeamStaffIdRoute: typeof AuthenticatedTeamStaffIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedAiIndexRoute: typeof AuthenticatedAiIndexRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedAppointmentsIndexRoute: typeof AuthenticatedAppointmentsIndexRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedConversationsIndexRoute: typeof AuthenticatedConversationsIndexRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
  AuthenticatedOpportunitiesIndexRoute: typeof AuthenticatedOpportunitiesIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedOverviewIndexRoute: typeof AuthenticatedOverviewIndexRoute
  AuthenticatedPurchasesIndexRoute: typeof AuthenticatedPurchasesIndexRoute
  AuthenticatedQueuesIndexRoute: typeof AuthenticatedQueuesIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedStoresIndexRoute: typeof AuthenticatedStoresIndexRoute
  AuthenticatedSystemIndexRoute: typeof AuthenticatedSystemIndexRoute
  AuthenticatedTeamIndexRoute: typeof AuthenticatedTeamIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedAiRunsAiRunIdRoute: typeof AuthenticatedAiRunsAiRunIdRoute
  AuthenticatedAiFollowupsIndexRoute: typeof AuthenticatedAiFollowupsIndexRoute
  AuthenticatedAiPromptIndexRoute: typeof AuthenticatedAiPromptIndexRoute
  AuthenticatedOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  AuthenticatedQueuesQueueIndexRoute: typeof AuthenticatedQueuesQueueIndexRoute
  AuthenticatedQueuesQueueJobsJobIdRoute: typeof AuthenticatedQueuesQueueJobsJobIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditEventIdRoute: AuthenticatedAuditEventIdRoute,
  AuthenticatedConversationsConversationIdRoute:
    AuthenticatedConversationsConversationIdRoute,
  AuthenticatedIntegrationsIntegrationIdRoute:
    AuthenticatedIntegrationsIntegrationIdRoute,
  AuthenticatedOpportunitiesOpportunityIdRoute:
    AuthenticatedOpportunitiesOpportunityIdRoute,
  AuthenticatedStoreStoreIdRoute: AuthenticatedStoreStoreIdRoute,
  AuthenticatedStoresStoreIdRoute: AuthenticatedStoresStoreIdRoute,
  AuthenticatedTeamStaffIdRoute: AuthenticatedTeamStaffIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedAiIndexRoute: AuthenticatedAiIndexRoute,
  AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  AuthenticatedAppointmentsIndexRoute: AuthenticatedAppointmentsIndexRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedConversationsIndexRoute: AuthenticatedConversationsIndexRoute,
  AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
  AuthenticatedOpportunitiesIndexRoute: AuthenticatedOpportunitiesIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedOverviewIndexRoute: AuthenticatedOverviewIndexRoute,
  AuthenticatedPurchasesIndexRoute: AuthenticatedPurchasesIndexRoute,
  AuthenticatedQueuesIndexRoute: AuthenticatedQueuesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedStoresIndexRoute: AuthenticatedStoresIndexRoute,
  AuthenticatedSystemIndexRoute: AuthenticatedSystemIndexRoute,
  AuthenticatedTeamIndexRoute: AuthenticatedTeamIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedAiRunsAiRunIdRoute: AuthenticatedAiRunsAiRunIdRoute,
  AuthenticatedAiFollowupsIndexRoute: AuthenticatedAiFollowupsIndexRoute,
  AuthenticatedAiPromptIndexRoute: AuthenticatedAiPromptIndexRoute,
  AuthenticatedOrganizationsOrganizationIdIndexRoute:
    AuthenticatedOrganizationsOrganizationIdIndexRoute,
  AuthenticatedQueuesQueueIndexRoute: AuthenticatedQueuesQueueIndexRoute,
  AuthenticatedQueuesQueueJobsJobIdRoute:
    AuthenticatedQueuesQueueJobsJobIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
